(function() {
  // Configuration based on actual Andreani data
  // Overlapping makes: DUCATI, HARLEY DAVIDSON, HUSQVARNA
  const categoryConfig = {
    motorcycles: {
      // Motorcycle-only makes (all models allowed)
      'APRILIA': '*',
      'BENELLI': '*',
      'BETA': '*',
      'BIMOTA': '*',
      'BMW': '*',
      'BUELL': '*',
      'CAGIVA': '*',
      'CAN AM': '*',
      'CFMOTO': '*',
      'FANTIC': '*',
      'GAS GAS': '*',
      'HONDA': '*',
      'Harley Davidson': '*',
      'Honda': '*',
      'INDIAN': '*',
      'KAWASAKI': '*',
      'KOVE': '*',
      'KRAMER': '*',
      'KTM': '*',
      'KYMCO': '*',
      'LAVERDA': '*',
      'MOTO GUZZI': '*',
      'MOTO MORINI': '*',
      'MV AGUSTA': '*',
      'OHVALE': '*',
      'PIAGGIO': '*',
      'ROYAL ENFIELD': '*',
      'SHERCO': '*',
      'STARK': '*',
      'STARK VARG': '*',
      'SUZUKI': '*',
      'TM': '*',
      'TRIUMPH': '*',
      'UNIVERSAL': '*',
      'VICTORY': '*',
      'YAMAHA': '*',
      'ZERO': '*',
      // Overlapping makes with specific motorcycle models
      'DUCATI': ["1098", "1098 R", "1098 S", "1198", "600 SS", "748", "748 BIPOSTO", "748 R", "748 SPS", "749", "749 R", "750 F1", "750 SPORT", "750 SS", "848", "851", "888", "900 SL", "900 SPORT", "900 SS", "916", "916 BIPOSTO", "916 SP", "996", "996 BIPOSTO", "996 R", "996 S", "998", "998 S", "999", "DESERT X", "DESMO 450 MX", "DIAVEL", "DIAVEL 1200 CARBON", "DIAVEL V4", "Desmosedici RR", "GT 1000", "HYPERMOTARD 1100", "HYPERMOTARD 1100 EVO", "HYPERMOTARD 1100 S", "HYPERMOTARD 1100 SP", "HYPERMOTARD 698", "HYPERMOTARD 796", "HYPERMOTARD 821", "HYPERMOTARD 821 SP", "HYPERMOTARD 821 SP EVO", "HYPERMOTARD 939", "HYPERMOTARD 950", "HYPERSTRADA", "HYPERSTRADA 821", "HYPERSTRADA 821 LOW", "HYPERSTRADA 859", "HYPERSTRADA 939", "HyperMotard 939", "HyperStrada 939", "Hypermotard 1100", "Hypermotard 1100 Evo", "Hypermotard 1100 S", "Hypermotard 796", "Hypermotard 821", "Hypermotard 821 SP", "Hypermotard 939", "Hypermotard 950", "Hyperstrada 821", "Hyperstrada 939", "INDIANA 350", "MH 900", "MONSTER 1000", "MONSTER 1000 DARK", "MONSTER 1100", "MONSTER 1100 EVO", "MONSTER 1200", "MONSTER 600", "MONSTER 620", "MONSTER 695", "MONSTER 696", "MONSTER 750", "MONSTER 795", "MONSTER 796", "MONSTER 797", "MONSTER 800", "MONSTER 821", "MONSTER 821 Stripe", "MONSTER 900", "MONSTER 937", "MONSTER 950", "MONSTER S2R", "MONSTER S2R 1000", "MONSTER S2R 800", "MONSTER S4", "MONSTER S4R", "MONSTER S4RS", "MULTISTRADA  950", "MULTISTRADA 1000", "MULTISTRADA 1100", "MULTISTRADA 1200", "MULTISTRADA 1200 S", "MULTISTRADA 1260", "MULTISTRADA 1260 S", "MULTISTRADA 620", "MULTISTRADA 950", "MULTISTRADA V2 S", "MULTISTRADA V4", "MULTISTRADA V4 S", "Monster 1000", "Monster 1100", "Monster 1200", "Monster 600", "Monster 620", "Monster 620 S", "Monster 695", "Monster 696", "Monster 750", "Monster 797", "Monster 800", "Monster 821", "Monster 900", "Monster S2R 1000", "Monster S2R 800", "Monster S4", "Monster S4R", "Monster S4RS", "Multistrada 1000", "Multistrada 1100", "Multistrada 1100 S", "Multistrada 1200 Enduro", "Multistrada 620", "PANIGALE 1199", "PANIGALE 1199 R", "PANIGALE 1199 S", "PANIGALE 1299", "PANIGALE 1299 S", "PANIGALE 899", "PANIGALE 959", "PANIGALE SUPERLEGGERA", "PANIGALE V2", "PANIGALE V4", "PANIGALE V4 R", "PANIGALE V4 S", "PASO 906", "PAUL SMART", "Panigale 1199", "Panigale 1199 R", "Panigale 1199 S", "Panigale 1299 S", "Panigale V2", "Panigale V4", "Panigale V4 R", "Panigale V4 S", "PaulSmart", "SCRAMBLER", "SCRAMBLER 1100", "SCRAMBLER 400", "SCRAMBLER 400/SIXTY2", "SCRAMBLER 800", "SCRAMBLER CLASSIC 2015", "SCRAMBLER DESERT SLED", "SPORT 1000", "SPORT 620", "SPORT CLASSIC", "SS", "SS 1000", "SS 620", "SS 620 S", "SS 750", "SS 800", "SS 900", "SS 900 S", "SS 939", "SS 950", "SS 950 S", "ST2", "ST3", "ST4", "STREETFIGHTER 1098", "STREETFIGHTER 1100", "STREETFIGHTER 848", "STREETFIGHTER V2", "STREETFIGHTER V4", "STREETFIGHTER V4 1100", "Scrambler 1100", "Scrambler 400/SIXTY2", "Scrambler 450", "Scrambler 800", "Scrambler Desert Sled", "Sport 1000", "Sport 1000 S", "Streetfighter 848", "Streetfighter S", "Streetfighter V4", "Superleggera V4", "X-DIAVEL"],
      'HARLEY DAVIDSON': ["DYNA FXD", "DYNA LOW RIDER", "DYNA SUPERGLIDE", "DYNA WIDE GLIDE", "Dyna FXD", "ELECTRA GLIDE", "FAT BOB", "FLST 1340 HERITAGE SOFTAIL", "FLSTC 1340 HERITAGE SOFTAIL CLASSIC", "FLSTF 1340 FAT BOY", "FXDB DYNA STREET BOB", "FXDWG 1690 DYNA WIDE GLIDE", "FXLR 1340 LOW RIDER CUSTOM", "FXR 1340 LOW RIDER", "FXR 1340 SUPER GLIDE", "NIGHT ROD", "Night Rod Special", "PAN AMERICA 1250", "PAN AMERICA 1250 S", "ROAD GLIDE", "ROAD GLIDE  1745 cc", "ROAD GLIDE CVO", "ROAD KING", "SOFTAIL", "SOFTAIL BREAKOUT", "SOFTAIL CUSTOM", "SOFTAIL DELUXE", "SOFTAIL FAT BOB", "SOFTAIL FAT BOY", "SOFTAIL FXDR 114", "SOFTAIL HERITAGE CLASSIC", "SOFTAIL LOW RIDER", "SOFTAIL LOW RIDER S", "SOFTAIL LOW RIDER ST", "SOFTAIL SLIM", "SOFTAIL SPORT GLIDE", "SOFTAIL STREET BOB", "SPORTSTER", "SPORTSTER (883,1200,CUSTOM,ECC)", "SPORTSTER 1250 S", "SPORTSTER 48", "SPORTSTER S", "SPORTSTER XL 1200 CX", "SPORTSTER XL1200N", "SPORTSTER XL1200X", "SPORTSTER XL883N", "STREET 500", "STREET 750", "STREET GLIDE", "STREET GLIDE CVO", "STREET ROD 750", "SWITCHBACK", "Softail Sport Glide", "TOURING", "TRI GLIDE", "ULTRA CLASSIC", "ULTRA LIMITED", "V-ROD", "VRSCA V-ROD", "VRSCB V-ROD", "VRSCDX 1130 NIGHT ROD SPECIAL", "VRSCDX 1250 NIGHT ROD SPECIAL", "VRSCDX NIGHT ROD SPECIAL", "XG 750A STREET ROD", "XL 1200 C", "XLH 1200 SPORTSTER", "XLH 883 SPORTSTER", "XLH 883 SPORTSTER DELUXE", "XLH 883 SPORTSTER HUGGER", "XR 1200"],
      'HUSQVARNA': ["701 ENDURO", "701 Enduro", "701 SUPERMOTO", "CR 125", "CR 250", "FC 250", "FC 350", "FC 450", "FE", "FE 250", "FE 350", "FE 450", "FE 501", "FS 450", "FX 350", "FX 450", "NORDEN 901", "NUDA 900", "Nuda 900", "Nuda 900 R", "SM 400 R", "SM 450 R", "SM 510 R", "SM 570 R", "SM 610", "SM 610 IE", "SM 610 R", "SM 630 S", "SVARTPILEN 401", "TC 125", "TC 250", "TC 300", "TC 450", "TC 50", "TC 510", "TC 65", "TC 85", "TE", "TE 125", "TE 150", "TE 150i", "TE 250", "TE 250i", "TE 300", "TE 300i", "TE 400", "TE 410", "TE 450", "TE 510", "TE 570", "TE 610", "TE 630", "TX 125", "TX 300", "VITPILEN 401", "VITPILEN 701", "WR 125", "WR 250", "WR 360"],
    },
    bikes: {
      // Bike-only makes (all models allowed)
      'ACTOFIVE': '*',
      'ANTIDOTE': '*',
      'BANSHEE': '*',
      'BIRD': '*',
      'BMC': '*',
      'CANFIELD': '*',
      'CANNONDALE': '*',
      'CANYON': '*',
      'COMMENCAL': '*',
      'CUBE': '*',
      'DARTMOORE': '*',
      'DEVIATE': '*',
      'DEVINCI': '*',
      'DT Swiss': '*',
      'EMINENT': '*',
      'EVIL': '*',
      'FOCUS': '*',
      'FORBIDDEN': '*',
      'FOX': '*',
      'GAMUX': '*',
      'GHOST': '*',
      'GIANT': '*',
      'GT': '*',
      'GT FORCE': '*',
      'GUERRILLA GRAVITY': '*',
      'HAIBIKE': '*',
      'HOPE': '*',
      'IBIS': '*',
      'INTENSE': '*',
      'KAVENZ': '*',
      'KNOLLY': '*',
      'KONA': '*',
      'KROSS': '*',
      'LAPIERRE': '*',
      'LITEVILLE': '*',
      'MANITOU': '*',
      'MARIN': '*',
      'MDE': '*',
      'MEGAMO': '*',
      'MERIDA': '*',
      'MONDRAKER': '*',
      'MOUSTACHE': '*',
      'Marzocchi': '*',
      'NICOLAI': '*',
      'NINER': '*',
      'NORCO': '*',
      'NS': '*',
      'NUKEPROOF': '*',
      'OHLINS': '*',
      'ORANGE': '*',
      'ORBEA': '*',
      'PIVOT': '*',
      'POLE': '*',
      'POLYGON': '*',
      'PRIVATEER': '*',
      'PROPAIN': '*',
      'PYGA': '*',
      'RAAW': '*',
      'REVEL': '*',
      'ROCKY': '*',
      'ROCKY MOUNTAIN': '*',
      'ROSE': '*',
      'Rockshox': '*',
      'SALSA': '*',
      'SANTA CRUZ': '*',
      'SARACEN': '*',
      'SCOR': '*',
      'SCOTT': '*',
      'SPECIALIZED': '*',
      'SPOT': '*',
      'STANTON': '*',
      'STARLING': '*',
      'THOK': '*',
      'TRANSITION': '*',
      'TREK': '*',
      'WE ARE ONE': '*',
      'WHYTE': '*',
      'X-FUSION': '*',
      'YETI': '*',
      'YT': '*',
      'ZERODE': '*',
      // Overlapping makes with specific bike models
      'DUCATI': ["TK01 RR"],
      'HARLEY DAVIDSON': ["TOURING"],
      'HUSQVARNA': ["HARD CROSS"],
    }
  };

  let allMakeOptions = [];
  let currentCategory = null;
  let modelObserver = null;

  // Create the category selector UI
  function createCategorySelector() {
    const mmyBar = document.querySelector('.gv-mmy-bar');
    if (!mmyBar) return false;

    if (document.querySelector('.category-selector')) return true;

    const selectorDiv = document.createElement('div');
    selectorDiv.className = 'category-selector';
    selectorDiv.innerHTML = `
      <div class="category-buttons">
        <button type="button" class="category-btn" data-category="motorcycles">Motorcycles</button>
        <button type="button" class="category-btn" data-category="bikes">Bikes</button>
      </div>
    `;

    // Insert into wrapper if it exists, otherwise into mmyBar
    const wrapper = mmyBar.querySelector('.wrapper');
    if (wrapper) {
      wrapper.insertBefore(selectorDiv, wrapper.firstChild);
    } else {
      mmyBar.insertBefore(selectorDiv, mmyBar.firstChild);
    }

    selectorDiv.querySelectorAll('.category-btn').forEach(btn => {
      btn.addEventListener('click', function() {
        const category = this.dataset.category;
        setCategory(category);
        
        selectorDiv.querySelectorAll('.category-btn').forEach(b => b.classList.remove('active'));
        this.classList.add('active');
      });
    });

    return true;
  }

  // Store all original make options
  function captureAllMakes() {
    const makeSelect = document.querySelector('.gv-mmy-bar select.mk');
    if (!makeSelect || makeSelect.options.length <= 1) return false;
    
    if (makeSelect.options[0]?.value === '' && makeSelect.options[0]?.text === 'Loading') {
      return false;
    }

    if (allMakeOptions.length === 0) {
      allMakeOptions = Array.from(makeSelect.options).map(opt => ({
        value: opt.value,
        text: opt.text
      }));
    }
    return true;
  }

  // Check if a make belongs to a category (case-insensitive)
  function makeInCategory(makeName, category) {
    const config = categoryConfig[category] || {};
    const makeNameLower = makeName.toLowerCase();
    return Object.keys(config).some(make => 
      makeNameLower === make.toLowerCase()
    );
  }

  // Get config key for a make (handles case differences)
  function getConfigKey(makeName, category) {
    const config = categoryConfig[category] || {};
    const makeNameLower = makeName.toLowerCase();
    return Object.keys(config).find(make => 
      makeNameLower === make.toLowerCase()
    );
  }

  // Check if a model belongs to the current category for a given make
  function modelInCategory(makeName, modelName, category) {
    const config = categoryConfig[category] || {};
    const makeKey = getConfigKey(makeName, category);

    if (!makeKey) return false;

    const allowedModels = config[makeKey];
    
    if (allowedModels === '*') return true;

    const modelNameLower = modelName.toLowerCase();
    return allowedModels.some(model =>
      modelNameLower === model.toLowerCase()
    );
  }

  // Filter makes by category
  function setCategory(category, preserveSelections = false) {
    currentCategory = category;
    const makeSelect = document.querySelector('.gv-mmy-bar select.mk');
    if (!makeSelect || allMakeOptions.length === 0) return;

    // Store current selection if preserving
    const currentMakeValue = preserveSelections ? makeSelect.value : '';

    makeSelect.innerHTML = '';

    allMakeOptions.forEach(opt => {
      if (opt.value === '' || makeInCategory(opt.text, category)) {
        const option = document.createElement('option');
        option.value = opt.value;
        option.text = opt.text;
        // Restore selection if it matches
        if (preserveSelections && opt.value === currentMakeValue) {
          option.selected = true;
        }
        makeSelect.appendChild(option);
      }
    });

    // Only reset dependent dropdowns if not preserving selections
    if (!preserveSelections) {
      resetDependentDropdowns();
    }
    
    setupModelObserver();
  }

  // Watch for model dropdown changes and filter accordingly
  function setupModelObserver() {
    const modelSelect = document.querySelector('.gv-mmy-bar select.md');
    const makeSelect = document.querySelector('.gv-mmy-bar select.mk');
    
    if (!modelSelect) return;

    if (modelObserver) {
      modelObserver.disconnect();
    }

    modelObserver = new MutationObserver((mutations) => {
      const hasNewOptions = mutations.some(m => 
        m.type === 'childList' && m.addedNodes.length > 0
      );

      if (hasNewOptions && currentCategory) {
        const selectedMake = makeSelect.options[makeSelect.selectedIndex]?.text;
        if (selectedMake) {
          filterModelOptions(selectedMake);
        }
      }
    });

    modelObserver.observe(modelSelect, { childList: true });
  }

  // Filter model dropdown based on current category
  function filterModelOptions(currentMake) {
    if (!currentCategory || !currentMake) return;

    const modelSelect = document.querySelector('.gv-mmy-bar select.md');
    if (!modelSelect) return;

    const currentOptions = Array.from(modelSelect.options).map(opt => ({
      value: opt.value,
      text: opt.text
    }));

    if (currentOptions.length <= 1) return;

    const makeKey = getConfigKey(currentMake, currentCategory);
    if (!makeKey) return;
    
    const config = categoryConfig[currentCategory];
    if (config[makeKey] === '*') return;

    if (modelObserver) modelObserver.disconnect();

    modelSelect.innerHTML = '';

    currentOptions.forEach(opt => {
      if (opt.value === '' || modelInCategory(currentMake, opt.text, currentCategory)) {
        const option = document.createElement('option');
        option.value = opt.value;
        option.text = opt.text;
        modelSelect.appendChild(option);
      }
    });

    setupModelObserver();
  }

  // Reset model and year dropdowns
  function resetDependentDropdowns() {
    const modelSelect = document.querySelector('.gv-mmy-bar select.md');
    const yearSelect = document.querySelector('.gv-mmy-bar select.yr');
    
    if (modelSelect) {
      modelSelect.innerHTML = '<option value="">Select Model</option>';
    }
    if (yearSelect) {
      yearSelect.innerHTML = '<option value="">Select Year</option>';
    }
  }

  // Initialize
  function init() {
    const selectorCreated = createCategorySelector();
    const makesLoaded = captureAllMakes();

    if (!selectorCreated || !makesLoaded) {
      setTimeout(init, 200);
    } else {
      // Check if there's an existing make selection
      const makeSelect = document.querySelector('.gv-mmy-bar select.mk');
      const currentMakeValue = makeSelect?.value;
      const currentMakeText = makeSelect?.options[makeSelect.selectedIndex]?.text;
      
      let detectedCategory = 'motorcycles'; // default
      let hasExistingSelection = currentMakeValue && currentMakeValue !== '';
      
      // If there's a selection, detect which category it belongs to
      // Only set to bikes if it's EXCLUSIVELY a bike make (not in motorcycles)
      if (hasExistingSelection && currentMakeText) {
        const inBikes = makeInCategory(currentMakeText, 'bikes');
        const inMotorcycles = makeInCategory(currentMakeText, 'motorcycles');
        
        if (inBikes && !inMotorcycles) {
          detectedCategory = 'bikes';
        }
        // For overlapping makes (DUCATI, HARLEY DAVIDSON, HUSQVARNA), default to motorcycles
      }
      
      // Set the active button
      const categoryBtn = document.querySelector(`.category-btn[data-category="${detectedCategory}"]`);
      if (categoryBtn) {
        categoryBtn.classList.add('active');
      }
      
      // Apply category filter, preserving selections if they exist
      setCategory(detectedCategory, hasExistingSelection);

      // Reveal the component now that initialization is complete
      const mmyBar = document.querySelector('.gv-mmy-bar');
      if (mmyBar) {
        mmyBar.classList.add('mmy-initialized');
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();